module.exports = __webpack_public_path__ + "static/media/journalApplyPic.03dd7bf1.png";